<div class="page-data">
    <app-advanced-search (formData)="applyFilters($event)" [config]="filterConfig"> </app-advanced-search>
    <div class="p-relative c-table">
        @if (showBackBtn) {
            <button class="back-btn p-absolute" (click)="turnBack()" color="primary" mat-button>
                <mat-icon>arrow_back</mat-icon>
                Назад
            </button>
        }
        <app-loader [isLoading]="logsTableService.loading()" />
        <app-common-table
            [config]="tableConfig"
            [service]="logsTableService"
            (actions)="applyAction($event)"
        >
        </app-common-table>
    </div>
</div>
